import React, { useState } from "react";
import {
  Box,
} from "@mui/material";

import FolderSection from "./FolderSection";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

const UploadForm = ({customerId }) => {
  const [tabvalue, settabvalue] = useState(0);
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [selectedSubfolder, setSelectedSubfolder] = useState(null);
  const [fileInput, setFileInput] = useState(null);

  return (
    <Box
      sx={{
        backgroundColor: "transparent",
        borderRadius: 0,
        boxShadow: 0,
        marginLeft: 1,
        padding: "0 20px",
        margin: "0",
        width: "100%",
        boxSizing: 'border-box'
      }}
    >

      <TabPanel value={tabvalue} index={0}>

        <FolderSection
          setFolders={setFolders}
          folders={folders}
          selectedFolder={selectedFolder}
          selectedSubfolder={selectedSubfolder}
          setSelectedFolder={setSelectedFolder}
          setSelectedSubfolder={setSelectedSubfolder}
          setFileInput={setFileInput}
          customerId={customerId}
        />
      </TabPanel>

    </Box>
  );
};

export default UploadForm;

